/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import {
    SETTINGS_VIDEO_WINDOW_SET_GHOST_MODE,
    SETTINGS_VIDEO_WINDOW_SET_SELECTED_OPTION,
    SETTINGS_VIDEO_WINDOW_SET_ACTIVE,
} from './settingsvideowindow.types';

export const settingsVideoWindowEnableGhostModeAction = (
    isGhostModeActive: boolean,
): AnyAction => ({
    type: SETTINGS_VIDEO_WINDOW_SET_GHOST_MODE,
    payload: {
        isGhostModeActive,
    },
});

export const settingsVideoWindowSetActiveAction = (isActive: boolean): AnyAction => ({
    type: SETTINGS_VIDEO_WINDOW_SET_ACTIVE,
    payload: {
        isActive,
    },
});

export const settingsVideoWindowSetSelectedOptionAction = (selectedOption: number): AnyAction => ({
    type: SETTINGS_VIDEO_WINDOW_SET_SELECTED_OPTION,
    payload: {
        selectedOption,
    },
});
